const fetchResourceFromURI = async (uri:any) => {
  const response = await fetch(uri);

  const blob = await response.blob();
  return blob;
};

export async function uploadFile(file:any, signedRequest:any, callback:any ){

    file = await fetchResourceFromURI(file.url);

    const xhr = new XMLHttpRequest();
    xhr.open('PUT', signedRequest);

    xhr.upload.onprogress = function (e) {
      if (e.lengthComputable) {
          if(callback){
            callback(file.name, ((e.loaded/ e.total)*100))
          }
      }
    }

    xhr.onloadstart = function (e) {
          if(callback){
            callback(file.name, "start")
          }
    }

    xhr.onloadend = function (e) {
          if(callback){
            callback(file.name, "end")
          }
    }

    xhr.onreadystatechange = () => {
      if(xhr.readyState === 4){
        if(xhr.status === 200){

        }
        else{

        }
      }
    };
    xhr.send(file);
}